import { apiGet } from "./requests";

export const getStatistics = () => {
  //?timeFrame=1year
  let path = "corporation-statistics/";
  return apiGet(path);
};
